'use strict'

import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FadeIn from 'react-fade-in'

import Costs from './Costs'
import Footer from './Footer'
import Form from './Form'
import Loader from './Loader'
import Title from './Title'

import { fetchData } from '../actions'
import { getLoading, getRates } from '../selectors'
import { calculateCost } from '../shared'

const App = () => {
  const dispatch = useDispatch()
  const rates = getRates()
  const loading = getLoading()

  const [fetched, setFetched] = useState(false)
  const [duration, setDuration] = useState(30)
  const [period, setPeriod] = useState(52)
  const [setup, setSetup] = useState(5)
  const [attendees, setAttendees] = useState(2)
  const [salary, setSalary] = useState(5000)
  const [fromCurrency, setFromCurrency] = useState('USD')
  const [toCurrency, setToCurrency] = useState('GBP')
  const [cost, setCost] = useState(0)
  const [annualCost, setAnnualCost] = useState(0)

  useEffect(() => {
    if (!fetched) {
      setFetched(true)
      dispatch(fetchData())
    }
  }, [fetched])

  const onChangeSelect = (name, option) => {
    switch (name) {
      case 'duration':
        setDuration(option.value)
        break
      case 'period':
        setPeriod(option.value)
        break
      case 'setup':
        setSetup(option.value)
        break
      case 'attendees':
        setAttendees(option.value)
        break
      case 'salary':
        setSalary(option.value)
        break
      case 'fromCurrency':
        setFromCurrency(option.value)
        break
      case 'toCurrency':
        setToCurrency(option.value)
        break
      default:
        break
    }
  }

  useEffect(() => {
    const { cost, annualCost } = calculateCost({
      salary,
      duration,
      setup,
      period,
      attendees
    })
    setCost(cost)
    setAnnualCost(annualCost)
  }, [duration, period, setup, attendees, salary])

  return (
    <div className='container max-w-6xl mx-auto px-3 py-4'>
      <FadeIn>
        <Title />
        <Form
          duration={duration}
          period={period}
          setup={setup}
          attendees={attendees}
          salary={salary}
          fromCurrency={fromCurrency}
          toCurrency={toCurrency}
          onChangeSelect={onChangeSelect}
        />
        <Costs
          cost={cost}
          annualCost={annualCost}
          rates={rates}
          fromCurrency={fromCurrency}
          toCurrency={toCurrency}
        />
        <Footer />
      </FadeIn>
      {loading && <Loader />}
    </div>
  )
}

export default App
